// extracted by mini-css-extract-plugin
export default {"container":"Lnhtz1","text":"by65Qm","buttonContainer":"HkC_qu"};